import getServiceVersionless from './getServiceVersionless';

const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com/zenbusiness/v1/shared-assets';

const sharedAssetMap = new Map([
  ['annual_report_service', '/s2/vector/sub-monthly-subscriptions.svg'],
  ['basic_email', '/s2/vector/sub-basic-email.svg'],
  ['static_website', '/s2/vector/sub-business-website.svg'],
  ['personal_credit_monitoring', '/s2/vector/sub-credit-monitoring.svg'],
  ['dba_compliance', '/s2/vector/sub-dba-compliance.svg'],
  ['domain_name_privacy', '/s2/vector/sub-domain-name-privacy.svg'],
  ['domain_name_reg', '/s2/vector/sub-domain-name-registration.svg'],
  ['domain_name_reg_sqsp_tier1', '/s2/vector/domain-name.svg'],
  ['domain_name_reg_sqsp_tier2', '/s2/vector/domain-name.svg'],
  ['domain_name_reg_sqsp_tier3', '/s2/vector/domain-name.svg'],
  ['domain_name_reg_sqsp_tier4', '/s2/vector/domain-name.svg'],
  ['expense_tracking', '/s2/vector/sub-expense-tracking.svg'],
  ['expense_tracking_with_tax_filing', '/s2/vector/sub-expense-tracking.svg'],
  ['smb_marketing_effectiveness_tool', '/s2/vector/sub-marketing-effectiveness.svg'],
  ['smb_mktg_effectiveness_tools_bundle', '/s2/vector/sub-marketing-effectiveness.svg'],
  ['smb_mktg_kickstarter_tools_bundle', '/s2/vector/sub-marketing-kickstarter.svg'],
  ['smb_website_audit_svc', '/s2/vector/sub-website-tools-bundle.svg'],
  ['smb_website_ecomm_bundle', '/s2/vector/ecommerce-website.svg'],
  ['smb_ecomm_addon', '/s2/vector/ecommerce-website.svg'],
  ['subscription_plan', '/s2/vector/sub-monthly-subscriptions.svg'],
  ['subscription_plan_ra', '/s2/vector/sub-monthly-subscriptions.svg'],
  ['ra_starter_plan', '/s2/vector/sub-ra-starter-plan.svg'],
  ['ra_pro_plan', '/s2/vector/sub-ra-starter-plan.svg'],
  ['registered_agent_service', '/s2/vector/sub-registered-agent.svg'],
  ['virtual_business_address', '/s2/vector/sub-virtual-mailing-address.svg'],
  ['website_tools_bundle', '/s2/vector/sub-website-tools-bundle.svg'],
  ['worry_free_service', '/s2/vector/sub-worry-free-compliance.svg'],
  ['starter_plan', '/s2/vector/sub-ra-starter-plan.svg'],
  ['pro_plan', '/s2/vector/sub-ra-starter-plan.svg'],
  ['premium_plan', '/s2/vector/sub-ra-starter-plan.svg'],
  ['zb_banking', '/s2/vector/sub-zenbusiness-banking.svg'],
  ['zb_money_essential', '/s2/vector/sub-banking.svg'],
  ['zb_money_pro', '/s2/vector/sub-banking.svg'],
  ['default', '/s2/vector/sub-fallback.svg']
]);

export default function getSharedAsset(serviceProductName) {
  let asset = sharedAssetMap.get(serviceProductName);

  if (!asset) {
    asset = sharedAssetMap.get(getServiceVersionless(serviceProductName));

    if (!asset) {
      asset = sharedAssetMap.get('default');
    }
  }

  return `${CLOUDINARY_BASE_URL}${asset}`;
}
